The input parameter for the `toggleVerifyWithSeekPass` mutation.
